import { createFileRoute } from "@tanstack/react-router";
import ManagementZones from "@/components/field/setup/ManagementZones";

export const Route = createFileRoute(
    "/dashboard/fields/$fieldId/setup/management-zones",
)({
    component: ManagementZonesPane,
});

function ManagementZonesPane() {
    return <ManagementZones />;
}
